import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const addSubscriber = async (data, token) => {
  const res = await axios({
    method: "post",
    url: baseurl + `/subscribe`,
    data: data,
    headers: {
      token: token,
    },
  });
  return res.data;
};
